(function () {
  'use strict';

  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const RESULT_KEYWORDS = /\b(resultado|resultados|piel|funcion|encant|recomend|suave|aclara|not[eé]|viendo|cambio|limpi|mejor|excelente|buen|producto|encanta)\b/i;

  function formatRating(meta, reviews) {
    if (meta && meta.average_rating != null) {
      const avg = Number(meta.average_rating);
      if (!Number.isNaN(avg)) {
        const display = Number.isInteger(avg) ? String(avg) : avg.toFixed(1).replace(/\.0$/, '');
        return display;
      }
    }

    if (!reviews.length) return '4.8';

    const sum = reviews.reduce((total, review) => total + (Number(review.stars) || 0), 0);
    const avg = sum / reviews.length;
    return Number.isInteger(avg) ? String(Math.round(avg)) : (Math.round(avg * 10) / 10).toFixed(1);
  }

  function formatTotal(meta, reviews) {
    const total = Number(meta?.total_count) || reviews.length || 145;
    return total;
  }

  function scoreReview(review) {
    let score = 0;
    if (review.featured) score += 100;
    if (Number(review.stars) === 5) score += 50;
    if (review.verified) score += 20;
    if (review.has_image && review.image_url) score += 5;

    const comment = String(review.comment || '').trim();
    if (comment.length >= 40) score += 8;
    if (comment.length >= 80) score += 6;
    if (RESULT_KEYWORDS.test(comment)) score += 15;

    return score;
  }

  function selectMiniReviews(reviews, limit) {
    const eligible = reviews.filter((review) => {
      return (
        review.verified &&
        Number(review.stars) === 5 &&
        String(review.comment || '').trim().length > 0
      );
    });

    const featured = eligible.filter((review) => review.featured);
    const pool = featured.length >= limit ? featured : eligible;

    return [...pool]
      .sort((a, b) => scoreReview(b) - scoreReview(a))
      .slice(0, limit);
  }

  function loadReviewsData(url) {
    if (!window.__MIMA_REVIEWS_DATA_PROMISE__) {
      window.__MIMA_REVIEWS_DATA_PROMISE__ = fetch(url, { credentials: 'same-origin' }).then((response) => {
        if (!response.ok) throw new Error('No se pudieron cargar las reseñas');
        return response.json();
      });
    }
    return window.__MIMA_REVIEWS_DATA_PROMISE__;
  }

  function productLabel(review) {
    const parts = [review.product_name, review.variant].filter(Boolean);
    return parts.join(' · ');
  }

  // Cadenas traducibles inyectadas por el snippet vía data-i18n-*.
  // Los defaults conservan el texto ES previo por si el atributo falta.
  const I18N = {
    verified: 'COMPRA VERIFICADA',
    status: 'Reseña %1 de %2',
  };

  function readI18n(root) {
    if (root.dataset.i18nVerified) I18N.verified = root.dataset.i18nVerified;
    if (root.dataset.i18nStatus) I18N.status = root.dataset.i18nStatus;
  }

  function statusText(index, total) {
    return I18N.status.replace('%1', index).replace('%2', total);
  }

  function buildCard(review, showPhotos) {
    const article = document.createElement('article');
    article.className = 'mima-reviews-mini__card';
    article.setAttribute('role', 'group');

    const stars = document.createElement('div');
    stars.className = 'mima-reviews-mini__card-stars';
    stars.setAttribute('aria-label', `${review.stars || 5} estrellas`);
    stars.textContent = '★'.repeat(Number(review.stars) || 5);

    const badge = document.createElement('span');
    badge.className = 'mima-reviews-mini__badge';
    badge.textContent = I18N.verified;

    const comment = document.createElement('p');
    comment.className = 'mima-reviews-mini__comment';
    comment.textContent = String(review.comment || '').trim();

    const footer = document.createElement('footer');
    footer.className = 'mima-reviews-mini__footer';

    if (showPhotos && review.has_image && review.image_url) {
      const img = document.createElement('img');
      img.className = 'mima-reviews-mini__photo';
      img.src = review.image_url;
      img.alt = `Foto de ${review.customer_name || 'cliente'}`;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 52;
      img.height = 52;
      img.addEventListener(
        'error',
        () => {
          img.remove();
        },
        { once: true }
      );
      footer.appendChild(img);
    }

    const author = document.createElement('div');
    author.className = 'mima-reviews-mini__author';

    const name = document.createElement('cite');
    name.className = 'mima-reviews-mini__name';
    name.textContent = review.customer_name || 'Cliente verificado';

    author.appendChild(name);

    const product = productLabel(review);
    if (product) {
      const productEl = document.createElement('span');
      productEl.className = 'mima-reviews-mini__product';
      productEl.textContent = product;
      author.appendChild(productEl);
    }

    footer.appendChild(author);

    article.appendChild(stars);
    article.appendChild(badge);
    article.appendChild(comment);
    article.appendChild(footer);

    return article;
  }

  function initCarousel(root, reviews) {
    readI18n(root);
    const nav = root.querySelector('[data-mima-reviews-mini-nav]');
    const rail = root.querySelector('[data-mima-reviews-mini-rail]');
    const prevBtn = root.querySelector('[data-mima-reviews-mini-prev]');
    const nextBtn = root.querySelector('[data-mima-reviews-mini-next]');
    const dotsWrap = root.querySelector('[data-mima-reviews-mini-dots]');
    const statusEl = root.querySelector('[data-mima-reviews-mini-status]');
    const showPhotos = root.dataset.showPhotos !== 'false';
    const count = reviews.length;

    if (!rail || !count) return;

    reviews.forEach((review) => {
      rail.appendChild(buildCard(review, showPhotos));
    });

    if (nav) nav.hidden = false;

    let activeIndex = 0;

    function updateStatus() {
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.textContent = statusText(activeIndex + 1, count);
      }
    }

    function scrollToIndex(index, behavior) {
      const cards = rail.querySelectorAll('.mima-reviews-mini__card');
      const card = cards[index];
      if (!card) return;

      activeIndex = index;
      rail.scrollTo({
        left: card.offsetLeft - rail.offsetLeft,
        behavior: behavior || (REDUCED_MOTION ? 'auto' : 'smooth'),
      });
      updateDots();
      updateArrows();
      updateStatus();
    }

    function updateDots() {
      if (!dotsWrap || count <= 1) {
        if (dotsWrap) dotsWrap.hidden = true;
        return;
      }

      dotsWrap.hidden = false;
      dotsWrap.innerHTML = '';

      for (let i = 0; i < count; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mima-reviews-mini__dot' + (i === activeIndex ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', statusText(i + 1, count));
        dot.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
        dot.addEventListener('click', () => scrollToIndex(i));
        dotsWrap.appendChild(dot);
      }
    }

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = activeIndex <= 0;
      if (nextBtn) nextBtn.disabled = activeIndex >= count - 1;
    }

    function syncFromScroll() {
      const cards = [...rail.querySelectorAll('.mima-reviews-mini__card')];
      if (!cards.length) return;

      const scrollLeft = rail.scrollLeft;
      let nearest = 0;
      let nearestDistance = Infinity;

      cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - rail.offsetLeft - scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearest = index;
        }
      });

      if (nearest !== activeIndex) {
        activeIndex = nearest;
        updateDots();
        updateArrows();
        updateStatus();
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (activeIndex > 0) scrollToIndex(activeIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        if (activeIndex < count - 1) scrollToIndex(activeIndex + 1);
      });
    }

    rail.addEventListener('scroll', () => {
      window.requestAnimationFrame(syncFromScroll);
    }, { passive: true });

    rail.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' && activeIndex > 0) {
        event.preventDefault();
        scrollToIndex(activeIndex - 1);
      }
      if (event.key === 'ArrowRight' && activeIndex < count - 1) {
        event.preventDefault();
        scrollToIndex(activeIndex + 1);
      }
    });

    updateDots();
    updateArrows();
    updateStatus();
  }

  function bindCta(root) {
    const cta = root.querySelector('[data-mima-reviews-mini-cta]');
    if (!cta) return;

    cta.addEventListener('click', (event) => {
      const targetId = (root.dataset.ctaTarget || '#MimaReviewsFull').replace(/^#/, '');
      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({
        behavior: REDUCED_MOTION ? 'auto' : 'smooth',
        block: 'start',
      });
    });
  }

  function setSummary(root, rating, total) {
    const meta = root.querySelector('[data-mima-reviews-mini-meta]');
    if (meta) {
      meta.textContent = `${rating} · ${total} opiniones verificadas`;
    }
  }

  function showError(root) {
    root.classList.add('is-error');
    root.classList.remove('is-loading');
    root.setAttribute('aria-busy', 'false');

    const meta = root.querySelector('[data-mima-reviews-mini-meta]');
    if (meta) {
      meta.textContent = '★★★★★ 4.8 · Opiniones verificadas';
    }

    const cta = root.querySelector('[data-mima-reviews-mini-cta]');
    if (cta && root.dataset.fallbackCta) {
      cta.textContent = root.dataset.fallbackCta;
    }
  }

  function initMini(root) {
    if (root.dataset.mimaMiniInitialized === 'true') return;
    root.dataset.mimaMiniInitialized = 'true';

    const dataUrl = root.dataset.dataUrl;
    if (!dataUrl) {
      showError(root);
      return;
    }

    const limit = Math.min(3, Math.max(1, Number(root.dataset.count) || 3));

    bindCta(root);

    loadReviewsData(dataUrl)
      .then((payload) => {
        const reviews = Array.isArray(payload.reviews) ? payload.reviews : [];
        const meta = payload.meta || {};
        const rating = formatRating(meta, reviews);
        const total = formatTotal(meta, reviews);
        const selected = selectMiniReviews(reviews, limit);

        setSummary(root, rating, total);

        const cta = root.querySelector('[data-mima-reviews-mini-cta]');
        if (cta && /145/.test(cta.textContent)) {
          cta.textContent = cta.textContent.replace(/145/g, String(total));
        }

        if (!selected.length) {
          showError(root);
          return;
        }

        initCarousel(root, selected);
        root.classList.remove('is-loading');
        root.setAttribute('aria-busy', 'false');
      })
      .catch(() => {
        showError(root);
      });
  }

  function boot() {
    document.querySelectorAll('[data-mima-reviews-mini]').forEach(initMini);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!section) return;
    section.querySelectorAll('[data-mima-reviews-mini]').forEach((root) => {
      root.dataset.mimaMiniInitialized = '';
      initMini(root);
    });
  });
})();
